﻿import $ from 'jquery';
export interface IBinder {
  getElements(parent: JQuery): JQuery;
  getBinding(cell: JQuery, rowData: Object): IBinding;
}

export interface IExternalElementBinder {
  key: string;
  compute(tableData: Object): Function;
  subscribe: ISubscribeFunction;
  extend(): IBehaviorFunction;
}
export interface IBinding {
  bindingName: string;
  bindTo: string;
}

export interface IValueBinding extends IBinding {
  dataName: string;
  dataValue: any;
}

export interface ICellBinding extends IValueBinding {
  //specify how to create this cell for a blank editor table row
  createEmptyValue(rowData): any;
}

export interface IBehaviorBinding extends IBinding {
  createEmptyValue?: Function;
  behavior: IBehaviorFunction;
}

export interface IBehaviorFunction {
  name: string;
  build(...args: any[]): void;
}
export interface ISubscribeFunction {
  (value: any): any;
}

export class BindingConverter {
  static toValueBinding(binding: IBinding): IValueBinding {
    var temp: any = binding;
    if (!temp.dataName || !temp.dataValue)
      return null;

    return {
      bindingName: binding.bindingName,
      bindTo: binding.bindingName,
      dataName: temp.dataName,
      dataValue: temp.dataValue
    };
  }

  static toCellBinding(binding: IBinding): ICellBinding {
    var temp: any = binding;
    var valueBinding = this.toValueBinding(temp);
    if (valueBinding == null || !temp.createEmptyValue)
      return null;

    return {
      bindingName: binding.bindingName,
      bindTo: binding.bindingName,
      dataName: temp.dataName,
      dataValue: temp.dataValue,
      createEmptyValue: temp.createEmptyValue
    };
  }

  static toBehaviorBinding(binding: IBinding): IBehaviorBinding {
    var temp: any = binding;

    return {
      bindingName: binding.bindingName,
      bindTo: binding.bindTo,
      behavior: temp.behavior
    };
  }
}
